module.exports = __webpack_public_path__ + "img/pic-s3-kreatorka-rozwiazan.png";